// import { supabase, hasSupabaseConfig } from './supabase';

// const STORAGE_KEY = 'wiiz_mock_database_v1';
// const PARTNER_ID = 'partner-demo-001';

// const initialData = {
//   partners: [
//     {
//       id: PARTNER_ID,
//       partner_name: 'Acme Learning Pvt. Ltd.',
//       contact_person: 'Demo Partner',
//       email: 'partner@wiiz.com',
//       phone: '+91 98765 43210',
//       agreement_url: '',
//       auth_user_id: null,
//       status: 'active',
//       created_at: '2026-08-12T09:00:00Z'
//     }
//   ]
// };

// function clone(value) {
//   return JSON.parse(JSON.stringify(value));
// }

// function readMock() {
//   try {
//     const stored = localStorage.getItem(STORAGE_KEY);
//     if (!stored) {
//       localStorage.setItem(STORAGE_KEY, JSON.stringify(initialData));
//       return clone(initialData);
//     }
//     return JSON.parse(stored);
//   } catch (error) {
//     return clone(initialData);
//   }
// }

// /*
//  * ===================== CONTENT — real Supabase table (`contents`) =====================
//  * PK column: content_id -> mapped to id.
//  */
// const mapContentRow = row => (row ? { ...row, id: row.content_id } : row);

// const contentService = {
//   list: async () => {
//     const { data, error } = await supabase
//       .from('contents')
//       .select('*')
//       .order('created_at', { ascending: false });
//     if (error) return { data: null, error };
//     return { data: (data || []).map(mapContentRow), error: null };
//   },
//   create: async (payload) => {
//     const { id: _ignored, ...rest } = payload;
//     const { data, error } = await supabase
//       .from('contents')
//       .insert([rest])
//       .select()
//       .single();
//     if (error) return { data: null, error };
//     return { data: mapContentRow(data), error: null };
//   },
//   update: async (rowId, payload) => {
//     const { id: _ignored, ...rest } = payload;
//     const { data, error } = await supabase
//       .from('contents')
//       .update(rest)
//       .eq('content_id', rowId)
//       .select()
//       .single();
//     if (error) return { data: null, error };
//     return { data: mapContentRow(data), error: null };
//   },
//   remove: async (rowId) => {
//     const { error } = await supabase.from('contents').delete().eq('content_id', rowId);
//     return { data: null, error: error || null };
//   }
// };

// /*
//  * ===================== PARTNERS — real Supabase table (`partners`) =====================
//  * PK column: partner_id -> mapped to id.
//  * industry -> primary_industry, agreement_url -> agreement_file_url (UI form vs real columns).
//  */
// const mapPartnerRow = row => {
//   if (!row) return row;
//   const { partner_id, primary_industry, agreement_file_url, ...rest } = row;
//   return {
//     ...rest,
//     id: partner_id,
//     partner_id,
//     industry: primary_industry,
//     agreement_url: agreement_file_url
//   };
// };

// const mapPartnerPayload = payload => {
//   const { id: _ignored, industry, agreement_url, ...rest } = payload;
//   return {
//     ...rest,
//     primary_industry: industry,
//     agreement_file_url: agreement_url
//   };
// };

// const partnerService = {
//   list: async () => {
//     const { data, error } = await supabase
//       .from('partners')
//       .select('*')
//       .order('created_at', { ascending: false });
//     if (error) return { data: null, error };
//     return { data: (data || []).map(mapPartnerRow), error: null };
//   },
//   create: async (payload) => {
//     const { data, error } = await supabase
//       .from('partners')
//       .insert([mapPartnerPayload(payload)])
//       .select()
//       .single();
//     if (error) return { data: null, error };
//     return { data: mapPartnerRow(data), error: null };
//   },
//   update: async (rowId, payload) => {
//     const { data, error } = await supabase
//       .from('partners')
//       .update(mapPartnerPayload(payload))
//       .eq('partner_id', rowId)
//       .select()
//       .single();
//     if (error) return { data: null, error };
//     return { data: mapPartnerRow(data), error: null };
//   },
//   delete: async (rowId) => {
//     const { error } = await supabase.from('partners').delete().eq('partner_id', rowId);
//     return { data: null, error: error || null };
//   }
// };

// /*
//  * ===================== ALLOCATIONS — real Supabase table (`partner_allocations`) =====================
//  * PK column: allocation_id -> mapped to id.
//  */
// const mapAllocationRow = row => (row ? { ...row, id: row.allocation_id } : row);

// const allocationService = {
//   list: async () => {
//     const { data, error } = await supabase
//       .from('partner_allocations')
//       .select('*')
//       .order('allocated_at', { ascending: false });
//     if (error) return { data: null, error };
//     return { data: (data || []).map(mapAllocationRow), error: null };
//   },
//   create: async (payload) => {
//     const { data, error } = await supabase
//       .from('partner_allocations')
//       .insert([{
//         partner_id: payload.partner_id,
//         content_id: payload.content_id,
//         status: payload.status || 'active'
//       }])
//       .select()
//       .single();
//     if (error) return { data: null, error };
//     return { data: mapAllocationRow(data), error: null };
//   },
//   remove: async (rowId) => {
//     const { error } = await supabase.from('partner_allocations').delete().eq('allocation_id', rowId);
//     return { data: null, error: error || null };
//   }
// };

// /*
//  * ===================== REGISTRATIONS — real Supabase table (`registrations`) =====================
//  * PK column: registration_id -> mapped to id.
//  * Holds WHO registered for WHICH content under WHICH partner
//  * (person_name, person_email, person_mobile, partner_id, content_id).
//  *
//  * ⚠️ Column names below are read off a partially-truncated schema screenshot.
//  * If create() throws "column ... does not exist", open Supabase Table Editor
//  * -> registrations and fix the field name here to match exactly.
//  */
// const mapRegistrationRow = row => (row ? { ...row, id: row.registration_id } : row);

// const registrationService = {
//   list: async () => {
//     const { data, error } = await supabase
//       .from('registrations')
//       .select('*')
//       .order('created_at', { ascending: false });
//     if (error) return { data: null, error };
//     return { data: (data || []).map(mapRegistrationRow), error: null };
//   },
//   create: async (payload) => {
//     const { data, error } = await supabase
//       .from('registrations')
//       .insert([{
//         partner_id: payload.partner_id,
//         content_id: payload.content_id,
//         person_name: payload.person_name,
//         person_email: payload.person_email,
//         person_mobile: payload.person_mobile
//       }])
//       .select()
//       .single();
//     if (error) return { data: null, error };
//     return { data: mapRegistrationRow(data), error: null };
//   }
// };

// /*
//  * ===================== REQUESTS — real Supabase table (`requests`) =====================
//  * PK column: request_id -> mapped to id.
//  * Only tracks the APPROVAL WORKFLOW state for a registration — it does NOT
//  * carry person/partner/content info itself, that lives on the linked
//  * `registrations` row (joined via registration_id in the UI).
//  *
//  * UI code uses `row.status`, so request_status <-> status is mapped here.
//  *
//  * ⚠️ payment_status has a DB check constraint:
//  *   CHECK (payment_status IN ('pending', 'paid', 'failed'))
//  * 'not_required' is NOT an allowed value — inserting it without an explicit
//  * override will throw a 23514 constraint violation. Default here is 'pending'.
//  * If you need a distinct "no payment needed" state, either pass
//  * payment_status: 'pending' explicitly at the call site and treat it as
//  * such in the UI, or widen the constraint in Postgres:
//  *   ALTER TABLE requests DROP CONSTRAINT requests_payment_status_check;
//  *   ALTER TABLE requests ADD CONSTRAINT requests_payment_status_check
//  *     CHECK (payment_status IN ('pending', 'paid', 'failed', 'not_required'));
//  */
// const mapRequestRow = row => {
//   if (!row) return row;
//   const { request_id, request_status, ...rest } = row;
//   return {
//     ...rest,
//     id: request_id,
//     request_id,
//     status: request_status
//   };
// };

// const requestService = {
//   list: async () => {
//     const { data, error } = await supabase
//       .from('requests')
//       .select('*')
//       .order('created_at', { ascending: false });
//     if (error) return { data: null, error };
//     return { data: (data || []).map(mapRequestRow), error: null };
//   },
//   // Used by partner-facing pages ("My Requests") to show only the
//   // requests that belong to the logged-in partner. `requests` has no
//   // partner_id column of its own — that lives on `registrations` — so we
//   // first fetch this partner's full registration rows (not just ids),
//   // then fetch requests whose registration_id is in that list, then join
//   // in `contents` locally so the UI can read row.person_name,
//   // row.person_email, and row.content.name directly.
//   mine: async (partnerId) => {
//     const { data: registrationRows, error: registrationError } = await supabase
//       .from('registrations')
//       .select('*')
//       .eq('partner_id', partnerId);

//     if (registrationError) return { data: null, error: registrationError };

//     const registrations = (registrationRows || []).map(mapRegistrationRow);
//     const registrationById = Object.fromEntries(registrations.map(r => [r.id, r]));
//     const registrationIds = registrations.map(r => r.id);
//     if (!registrationIds.length) return { data: [], error: null };

//     const [{ data: requestRows, error: requestError }, { data: contentRows, error: contentError }] = await Promise.all([
//       supabase
//         .from('requests')
//         .select('*')
//         .in('registration_id', registrationIds)
//         .order('created_at', { ascending: false }),
//       supabase.from('contents').select('*')
//     ]);

//     if (requestError) return { data: null, error: requestError };
//     if (contentError) return { data: null, error: contentError };

//     const contentById = Object.fromEntries((contentRows || []).map(mapContentRow).map(c => [c.id, c]));

//     const joined = (requestRows || []).map(mapRequestRow).map(request => {
//       const registration = registrationById[request.registration_id];
//       const contentItem = registration ? contentById[registration.content_id] : null;
//       return {
//         ...request,
//         registration,
//         content: contentItem,
//         person_name: registration?.person_name,
//         person_email: registration?.person_email
//       };
//     });

//     return { data: joined, error: null };
//   },
//   create: async (payload) => {
//     const { data, error } = await supabase
//       .from('requests')
//       .insert([{
//         registration_id: payload.registration_id,
//         request_status: payload.status || 'pending',
//         payment_status: payload.payment_status || 'pending'
//       }])
//       .select()
//       .single();
//     if (error) return { data: null, error };
//     return { data: mapRequestRow(data), error: null };
//   },
//   update: async (rowId, payload) => {
//     const { status, ...rest } = payload;
//     const updatePayload = { ...rest, updated_at: new Date().toISOString() };
//     if (status) {
//       updatePayload.request_status = status;
//       if (status !== 'pending') updatePayload.reviewed_at = new Date().toISOString();
//     }

//     const { data, error } = await supabase
//       .from('requests')
//       .update(updatePayload)
//       .eq('request_id', rowId)
//       .select()
//       .single();
//     if (error) return { data: null, error };
//     return { data: mapRequestRow(data), error: null };
//   }
// };

// /*
//  * ===================== CERTIFICATES — real Supabase table (`certificates`) =====================
//  * Actual columns (confirmed from information_schema):
//  *   certificate_uuid  uuid          -> PRIMARY KEY, mapped to `id`
//  *   certificate_id    varchar       -> human-readable code (e.g. "WZ-2026-AB12CD34"), NOT NULL, mapped to `certificate_number`
//  *   request_id        uuid
//  *   registration_id   uuid
//  *   content_id        uuid
//  *   person_name       varchar
//  *   person_email      varchar (nullable)
//  *   file_url          text          -> NOT NULL, so we generate+upload the PDF BEFORE inserting the row
//  *   issue_date        date
//  *   status            varchar
//  *   created_at        timestamp
//  */
// const mapCertificateRow = row => {
//   if (!row) return row;
//   const { certificate_uuid, certificate_id, ...rest } = row;
//   return {
//     ...rest,
//     id: certificate_uuid,
//     certificate_number: certificate_id
//   };
// };

// // Generates the PK uuid + human-readable code up front, so the caller can
// // build the verify URL / storage path / PDF content BEFORE the row exists.
// export function newCertificateIds() {
//   const certificate_uuid = crypto.randomUUID();
//   const certificate_id = `WZ-${new Date().getFullYear()}-${certificate_uuid.slice(0, 8).toUpperCase()}`;
//   return { certificate_uuid, certificate_id };
// }

// const certificateService = {
//   list: async () => {
//     const { data, error } = await supabase
//       .from('certificates')
//       .select('*')
//       .order('created_at', { ascending: false });
//     if (error) return { data: null, error };
//     return { data: (data || []).map(mapCertificateRow), error: null };
//   },
//   mine: async (partnerId) => {
//     const { data: registrationRows, error: registrationError } = await supabase
//       .from('registrations')
//       .select('registration_id')
//       .eq('partner_id', partnerId);

//     if (registrationError) return { data: null, error: registrationError };

//     const registrationIds = (registrationRows || []).map(row => row.registration_id);
//     if (!registrationIds.length) return { data: [], error: null };

//     const { data, error } = await supabase
//       .from('certificates')
//       .select('*')
//       .in('registration_id', registrationIds)
//       .order('created_at', { ascending: false });
//     if (error) return { data: null, error };
//     return { data: (data || []).map(mapCertificateRow), error: null };
//   },
//   // Expects certificate_uuid, certificate_id, and file_url to ALREADY be
//   // known/provided by the caller (see newCertificateIds + the upload step
//   // in Requests.jsx) — this way the row is only ever inserted complete,
//   // never in a broken half-finished state.
//   create: async (payload) => {
//     const {
//       certificate_uuid,
//       certificate_id,
//       request_id,
//       registration_id,
//       content_id,
//       person_name,
//       person_email,
//       file_url,
//       status
//     } = payload;

//     const { data, error } = await supabase
//       .from('certificates')
//       .insert([{
//         certificate_uuid,
//         certificate_id,
//         request_id,
//         registration_id,
//         content_id,
//         person_name,
//         person_email,
//         file_url,
//         status: status || 'issued'
//       }])
//       .select()
//       .single();
//     if (error) return { data: null, error };
//     return { data: mapCertificateRow(data), error: null };
//   },
//   update: async (rowId, payload) => {
//     const { data, error } = await supabase
//       .from('certificates')
//       .update(payload)
//       .eq('certificate_uuid', rowId)
//       .select()
//       .single();
//     if (error) return { data: null, error };
//     return { data: mapCertificateRow(data), error: null };
//   }
// };

// export const db = {
//   // Everything below now reads/writes the REAL Supabase tables.
//   content: contentService,
//   partners: partnerService,
//   allocations: allocationService,
//   registrations: registrationService,
//   requests: requestService,
//   certificates: certificateService
// };

// export async function getPartnerByAuth(uid) {
//   if (!hasSupabaseConfig) return { data: readMock().partners.find(row => row.auth_user_id === uid) || null, error: null };
//   return supabase.from('partners').select('*').eq('auth_user_id', uid).single();
// }

// export async function uploadCertificate(file, path) {
//   if (!hasSupabaseConfig) return { data: null, error: null, mock: true };
//   return supabase.storage.from('certificates').upload(path, file, { upsert: true, contentType: 'application/pdf' });
// }

// export async function publicCertificateUrl(path) {
//   if (!hasSupabaseConfig) return `${window.location.origin}/mock-certificates/${encodeURIComponent(path)}`;
//   return supabase.storage.from('certificates').getPublicUrl(path).data.publicUrl;
// }

// export function resetMockDatabase() {
//   localStorage.setItem(STORAGE_KEY, JSON.stringify(initialData));
//   window.location.reload();
// }

// export const demoCredentials = {
//   admin: { email: 'admin@wiiz.com', password: 'admin123' },
//   partner: { email: 'partner@wiiz.com', password: 'partner123', partnerId: PARTNER_ID }
// };






import { supabase, hasSupabaseConfig } from './supabase';

const STORAGE_KEY = 'wiiz_mock_database_v1';
const PARTNER_ID = 'partner-demo-001';

const initialData = {
  partners: [
    {
      id: PARTNER_ID,
      partner_name: 'Acme Learning Pvt. Ltd.',
      contact_person: 'Demo Partner',
      email: 'partner@wiiz.com',
      phone: '+91 98765 43210',
      agreement_url: '',
      auth_user_id: null,
      status: 'active',
      created_at: '2026-08-12T09:00:00Z'
    }
  ]
};

function clone(value) {
  return JSON.parse(JSON.stringify(value));
}

function readMock() {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);

    if (!stored) {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(initialData));
      return clone(initialData);
    }

    return JSON.parse(stored);
  } catch (error) {
    return clone(initialData);
  }
}

/* ============================================================
   CONTENT
   Real Supabase table: contents
   PK: content_id
   ============================================================ */

const mapContentRow = row => (row ? { ...row, id: row.content_id } : row);

const contentService = {
  list: async () => {
    const { data, error } = await supabase
      .from('contents')
      .select('*')
      .order('created_at', { ascending: false });

    if (error) return { data: null, error };

    return { data: (data || []).map(mapContentRow), error: null };
  },

  create: async payload => {
    const { id: _ignored, ...rest } = payload;

    const { data, error } = await supabase
      .from('contents')
      .insert([rest])
      .select()
      .single();

    if (error) return { data: null, error };

    return { data: mapContentRow(data), error: null };
  },

  update: async (rowId, payload) => {
    const { id: _ignored, ...rest } = payload;

    const { data, error } = await supabase
      .from('contents')
      .update(rest)
      .eq('content_id', rowId)
      .select()
      .single();

    if (error) return { data: null, error };

    return { data: mapContentRow(data), error: null };
  },

  remove: async rowId => {
    const { error } = await supabase.from('contents').delete().eq('content_id', rowId);

    return { data: null, error: error || null };
  }
};

/* ============================================================
   PARTNERS
   Real Supabase table: partners
   PK: partner_id
   ============================================================ */

const mapPartnerRow = row => {
  if (!row) return row;

  const { partner_id, primary_industry, agreement_file_url, ...rest } = row;

  return {
    ...rest,
    id: partner_id,
    partner_id,
    industry: primary_industry,
    agreement_url: agreement_file_url
  };
};

const mapPartnerPayload = payload => {
  const { id: _ignored, industry, agreement_url, ...rest } = payload;

  return {
    ...rest,
    primary_industry: industry,
    agreement_file_url: agreement_url
  };
};

const partnerService = {
  list: async () => {
    const { data, error } = await supabase
      .from('partners')
      .select('*')
      .order('created_at', { ascending: false });

    if (error) return { data: null, error };

    return { data: (data || []).map(mapPartnerRow), error: null };
  },

  create: async payload => {
    const { data, error } = await supabase
      .from('partners')
      .insert([mapPartnerPayload(payload)])
      .select()
      .single();

    if (error) return { data: null, error };

    return { data: mapPartnerRow(data), error: null };
  },

  update: async (rowId, payload) => {
    const { data, error } = await supabase
      .from('partners')
      .update(mapPartnerPayload(payload))
      .eq('partner_id', rowId)
      .select()
      .single();

    if (error) return { data: null, error };

    return { data: mapPartnerRow(data), error: null };
  },

  delete: async rowId => {
    const { error } = await supabase.from('partners').delete().eq('partner_id', rowId);

    return { data: null, error: error || null };
  }
};

/* ============================================================
   ALLOCATIONS
   Real Supabase table: partner_allocations
   PK: allocation_id
   ============================================================ */

const mapAllocationRow = row => (row ? { ...row, id: row.allocation_id } : row);

const allocationService = {
  list: async () => {
    const { data, error } = await supabase
      .from('partner_allocations')
      .select('*')
      .order('allocated_at', { ascending: false });

    if (error) return { data: null, error };

    return { data: (data || []).map(mapAllocationRow), error: null };
  },

  create: async payload => {
    const { data, error } = await supabase
      .from('partner_allocations')
      .insert([
        {
          partner_id: payload.partner_id,
          content_id: payload.content_id,
          status: payload.status || 'active'
        }
      ])
      .select()
      .single();

    if (error) return { data: null, error };

    return { data: mapAllocationRow(data), error: null };
  },

  remove: async rowId => {
    const { error } = await supabase
      .from('partner_allocations')
      .delete()
      .eq('allocation_id', rowId);

    return { data: null, error: error || null };
  }
};

/* ============================================================
   REGISTRATIONS
   Real Supabase table: registrations
   PK: registration_id
   ============================================================ */

const mapRegistrationRow = row => (row ? { ...row, id: row.registration_id } : row);

const registrationService = {
  /* LIST REGISTRATIONS */
  list: async () => {
    const { data, error } = await supabase
      .from('registrations')
      .select('*')
      .order('created_at', { ascending: false });

    if (error) return { data: null, error };

    return { data: (data || []).map(mapRegistrationRow), error: null };
  },

  /* SINGLE REGISTRATION ONLY — existing functionality */
  create: async payload => {
    const { data, error } = await supabase
      .from('registrations')
      .insert([
        {
          partner_id: payload.partner_id,
          content_id: payload.content_id,
          person_name: payload.person_name,
          person_email: payload.person_email,
          person_mobile: payload.person_mobile
        }
      ])
      .select()
      .single();

    if (error) return { data: null, error };

    return { data: mapRegistrationRow(data), error: null };
  },

  /* SINGLE REGISTRATION + REQUEST
     Flow: Person Register -> registrations -> requests -> pending */
  createWithRequest: async payload => {
    const { data: registration, error: registrationError } = await supabase
      .from('registrations')
      .insert([
        {
          partner_id: payload.partner_id,
          content_id: payload.content_id,
          person_name: payload.person_name,
          person_email: payload.person_email,
          person_mobile: payload.person_mobile
        }
      ])
      .select()
      .single();

    if (registrationError) return { data: null, error: registrationError };

    const { data: request, error: requestError } = await supabase
      .from('requests')
      .insert([
        {
          registration_id: registration.registration_id,
          request_status: 'pending',
          payment_status: payload.payment_status || 'pending'
        }
      ])
      .select()
      .single();

    if (requestError) return { data: null, error: requestError };

    return {
      data: {
        registration: mapRegistrationRow(registration),
        request: mapRequestRow(request)
      },
      error: null
    };
  },

  /* BULK REGISTRATION + REQUESTS (CSV)
     50 people -> 50 registrations -> 50 requests, every person gets a separate request */
  createBulkWithRequests: async (rows, partnerId, contentId, paymentStatus = 'pending') => {
    if (!rows || !rows.length) {
      return { data: null, error: new Error('No registration records found.') };
    }

    const registrationPayload = rows.map(row => ({
      partner_id: partnerId,
      content_id: contentId,
      person_name: row.person_name,
      person_email: row.person_email,
      person_mobile: row.person_mobile
    }));

    const { data: registrations, error: registrationError } = await supabase
      .from('registrations')
      .insert(registrationPayload)
      .select();

    if (registrationError) return { data: null, error: registrationError };

    const requestPayload = registrations.map(registration => ({
      registration_id: registration.registration_id,
      request_status: 'pending',
      payment_status: paymentStatus
    }));

    const { data: requests, error: requestError } = await supabase
      .from('requests')
      .insert(requestPayload)
      .select();

    if (requestError) return { data: null, error: requestError };

    return {
      data: {
        registrations: registrations.map(mapRegistrationRow),
        requests: requests.map(mapRequestRow)
      },
      error: null
    };
  }
};

/* Alias — creates ONLY registrations (no requests), matches call site:
   db.registrations.bulkCreate({ partner_id, content_id, people }) */
registrationService.bulkCreate = async ({ partner_id, content_id, people }) => {
  if (!people || !people.length) {
    return { data: null, error: new Error('No registration records found.') };
  }

  const registrationPayload = people.map(row => ({
    partner_id,
    content_id,
    person_name: row.person_name,
    person_email: row.person_email,
    person_mobile: row.person_mobile
  }));

  const { data, error } = await supabase
    .from('registrations')
    .insert(registrationPayload)
    .select();

  if (error) return { data: null, error };

  return { data: (data || []).map(mapRegistrationRow), error: null };
};

/* ============================================================
   REQUESTS
   Real Supabase table: requests
   PK: request_id
   ============================================================ */

const mapRequestRow = row => {
  if (!row) return row;

  const { request_id, request_status, ...rest } = row;

  return {
    ...rest,
    id: request_id,
    request_id,
    status: request_status
  };
};

const requestService = {
  /* ALL REQUESTS — Admin */
  list: async () => {
    const { data, error } = await supabase
      .from('requests')
      .select('*')
      .order('created_at', { ascending: false });

    if (error) return { data: null, error };

    return { data: (data || []).map(mapRequestRow), error: null };
  },

  /* PARTNER REQUESTS */
  mine: async partnerId => {
    const { data: registrationRows, error: registrationError } = await supabase
      .from('registrations')
      .select('*')
      .eq('partner_id', partnerId);

    if (registrationError) return { data: null, error: registrationError };

    const registrations = (registrationRows || []).map(mapRegistrationRow);
    const registrationById = Object.fromEntries(registrations.map(row => [row.id, row]));
    const registrationIds = registrations.map(row => row.id);

    if (!registrationIds.length) {
      return { data: [], error: null };
    }

    const [
      { data: requestRows, error: requestError },
      { data: contentRows, error: contentError }
    ] = await Promise.all([
      supabase
        .from('requests')
        .select('*')
        .in('registration_id', registrationIds)
        .order('created_at', { ascending: false }),
      supabase.from('contents').select('*')
    ]);

    if (requestError) return { data: null, error: requestError };
    if (contentError) return { data: null, error: contentError };

    const contentById = Object.fromEntries(
      (contentRows || []).map(mapContentRow).map(content => [content.id, content])
    );

    const joined = (requestRows || []).map(mapRequestRow).map(request => {
      const registration = registrationById[request.registration_id];
      const contentItem = registration ? contentById[registration.content_id] : null;

      return {
        ...request,
        registration,
        content: contentItem,
        person_name: registration?.person_name,
        person_email: registration?.person_email
      };
    });

    return { data: joined, error: null };
  },

  /* CREATE REQUEST MANUALLY */
  create: async payload => {
    const { data, error } = await supabase
      .from('requests')
      .insert([
        {
          registration_id: payload.registration_id,
          request_status: payload.status || 'pending',
          payment_status: payload.payment_status || 'pending'
        }
      ])
      .select()
      .single();

    if (error) return { data: null, error };

    return { data: mapRequestRow(data), error: null };
  },

  /* UPDATE REQUEST — Approve / Reject */
  update: async (rowId, payload) => {
    const { status, ...rest } = payload;

    const updatePayload = {
      ...rest,
      updated_at: new Date().toISOString()
    };

    if (status) {
      updatePayload.request_status = status;

      if (status !== 'pending') {
        updatePayload.reviewed_at = new Date().toISOString();
      }
    }

    const { data, error } = await supabase
      .from('requests')
      .update(updatePayload)
      .eq('request_id', rowId)
      .select()
      .single();

    if (error) return { data: null, error };

    return { data: mapRequestRow(data), error: null };
  },

  /* BULK APPROVE */
  approveBulk: async requestIds => {
    if (!requestIds?.length) {
      return { data: [], error: new Error('No requests selected.') };
    }

    const { data, error } = await supabase
      .from('requests')
      .update({
        request_status: 'approved',
        reviewed_at: new Date().toISOString(),
        updated_at: new Date().toISOString()
      })
      .in('request_id', requestIds)
      .select();

    if (error) return { data: null, error };

    return { data: (data || []).map(mapRequestRow), error: null };
  },

  /* BULK CREATE — one request per registration, matches call site:
     db.requests.bulkCreate(registrations) */
  bulkCreate: async registrations => {
    if (!registrations?.length) {
      return { data: [], error: new Error('No registrations provided.') };
    }

    const requestPayload = registrations.map(registration => ({
      registration_id: registration.registration_id || registration.id,
      request_status: 'pending',
      payment_status: 'pending'
    }));

    const { data, error } = await supabase
      .from('requests')
      .insert(requestPayload)
      .select();

    if (error) return { data: null, error };

    return { data: (data || []).map(mapRequestRow), error: null };
  },

  /* BULK REJECT */
  rejectBulk: async requestIds => {
    if (!requestIds?.length) {
      return { data: [], error: new Error('No requests selected.') };
    }

    const { data, error } = await supabase
      .from('requests')
      .update({
        request_status: 'rejected',
        reviewed_at: new Date().toISOString(),
        updated_at: new Date().toISOString()
      })
      .in('request_id', requestIds)
      .select();

    if (error) return { data: null, error };

    return { data: (data || []).map(mapRequestRow), error: null };
  }
};

/* ============================================================
   CERTIFICATES
   Real Supabase table: certificates
   ============================================================ */

const mapCertificateRow = row => {
  if (!row) return row;

  const { certificate_uuid, certificate_id, ...rest } = row;

  return {
    ...rest,
    id: certificate_uuid,
    certificate_number: certificate_id
  };
};

/* Generate Certificate IDs */
export function newCertificateIds() {
  const certificate_uuid = crypto.randomUUID();

  const certificate_id = `WZ-${new Date().getFullYear()}-${certificate_uuid
    .slice(0, 8)
    .toUpperCase()}`;

  return { certificate_uuid, certificate_id };
}

const certificateService = {
  list: async () => {
    const { data, error } = await supabase
      .from('certificates')
      .select('*')
      .order('created_at', { ascending: false });

    if (error) return { data: null, error };

    return { data: (data || []).map(mapCertificateRow), error: null };
  },

  /* PARTNER CERTIFICATES */
  mine: async partnerId => {
    const { data: registrationRows, error: registrationError } = await supabase
      .from('registrations')
      .select('registration_id')
      .eq('partner_id', partnerId);

    if (registrationError) return { data: null, error: registrationError };

    const registrationIds = (registrationRows || []).map(row => row.registration_id);

    if (!registrationIds.length) {
      return { data: [], error: null };
    }

    const { data, error } = await supabase
      .from('certificates')
      .select('*')
      .in('registration_id', registrationIds)
      .order('created_at', { ascending: false });

    if (error) return { data: null, error };

    return { data: (data || []).map(mapCertificateRow), error: null };
  },

  create: async payload => {
    const {
      certificate_uuid,
      certificate_id,
      request_id,
      registration_id,
      content_id,
      person_name,
      person_email,
      file_url,
      status
    } = payload;

    const { data, error } = await supabase
      .from('certificates')
      .insert([
        {
          certificate_uuid,
          certificate_id,
          request_id,
          registration_id,
          content_id,
          person_name,
          person_email,
          file_url,
          status: status || 'issued'
        }
      ])
      .select()
      .single();

    if (error) return { data: null, error };

    return { data: mapCertificateRow(data), error: null };
  },

  update: async (rowId, payload) => {
    const { data, error } = await supabase
      .from('certificates')
      .update(payload)
      .eq('certificate_uuid', rowId)
      .select()
      .single();

    if (error) return { data: null, error };

    return { data: mapCertificateRow(data), error: null };
  }
};

/* ============================================================
   DATABASE EXPORT
   ============================================================ */

export const db = {
  content: contentService,
  partners: partnerService,
  allocations: allocationService,
  registrations: registrationService,
  requests: requestService,
  certificates: certificateService
};

/* ============================================================
   PARTNER AUTH
   ============================================================ */

export async function getPartnerByAuth(uid) {
  if (!hasSupabaseConfig) {
    return {
      data: readMock().partners.find(row => row.auth_user_id === uid) || null,
      error: null
    };
  }

  return supabase.from('partners').select('*').eq('auth_user_id', uid).single();
}

/* ============================================================
   CERTIFICATE STORAGE
   ============================================================ */

export async function uploadCertificate(file, path) {
  if (!hasSupabaseConfig) {
    return { data: null, error: null, mock: true };
  }

  return supabase.storage.from('certificates').upload(path, file, {
    upsert: true,
    contentType: 'application/pdf'
  });
}

export async function publicCertificateUrl(path) {
  if (!hasSupabaseConfig) {
    return `${window.location.origin}/mock-certificates/${encodeURIComponent(path)}`;
  }

  return supabase.storage.from('certificates').getPublicUrl(path).data.publicUrl;
}

/* ============================================================
   RESET MOCK DATABASE
   ============================================================ */

export function resetMockDatabase() {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(initialData));
  window.location.reload();
}

/* ============================================================
   DEMO CREDENTIALS
   ============================================================ */

export const demoCredentials = {
  admin: {
    email: 'admin@wiiz.com',
    password: 'admin123'
  },
  partner: {
    email: 'partner@wiiz.com',
    password: 'partner123',
    partnerId: PARTNER_ID
  }
};